import { Component, Input, ViewEncapsulation } from '@angular/core';
import { RouseCategory } from 'src/app/core/models';
import { TranslateLabelPipe } from 'src/app/core/pipes/translate-label.pipe';

@Component({
  selector: 'app-categories-item',
  templateUrl: './categories-item.component.html',
  styleUrls: ['./categories-item.component.scss'],
  providers: [TranslateLabelPipe],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: false,
})
export class CategoriesItemComponent {
  @Input() item: RouseCategory;
  @Input() onClick: (category: RouseCategory) => void;
  @Input() allAssetsLabel: string;
  @Input() selectedCustomerCount: number;

  onClickItem(): void {
    this.onClick(this.item);
  }

  getUtilFillColor() {
    let color = 'darkred';
    const current = this.item.physical_utilization_current
      ? this.item.physical_utilization_current
      : 0;
    const bench = this.item.physical_utilization_bench
      ? this.item.physical_utilization_bench
      : 0;
    if (current >= bench) {
      color = 'green';
    }
    return color;
  }
}
